export default function cardsModal() {
  const roots = Array.from(document.querySelectorAll('[data-cards-modal]'));
  if (!roots.length) return;

  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const CLOSE_MS = 500;

  for (const root of roots) {
    const modalId = root.getAttribute('data-cards-modal');
    if (!modalId) continue;

    const modal = root.querySelector(`#${CSS.escape(modalId)}`);
    if (!modal) continue;

    const drawer = modal.querySelector('.cards-modal__drawer');
    const panels = Array.from(modal.querySelectorAll('.cards-modal__panel'));

    let lastFocused = null;
    let closeTimer = 0;

    const showPanel = (panelId) => {
      let active = null;
      for (const p of panels) {
        const isActive = p.id === panelId;
        p.hidden = !isActive;
        if (isActive) active = p;
      }
      // Link the dialog to the active panel's title for screen readers
      const title = active ? active.querySelector('.cards-modal__title') : null;
      if (drawer && title && title.id) {
        drawer.setAttribute('aria-labelledby', title.id);
      }
    };

    const open = (panelId, triggerEl) => {
      window.clearTimeout(closeTimer);
      lastFocused = triggerEl || document.activeElement;
      showPanel(panelId);

      document.body.style.overflow = 'hidden';
      modal.hidden = false;
      // Ensure transitions run reliably
      window.requestAnimationFrame(() => {
        modal.classList.add('cards-modal--open');
        const closeBtn = modal.querySelector('.cards-modal__close');
        if (closeBtn) closeBtn.focus();
      });
    };

    const close = () => {
      modal.classList.remove('cards-modal--open');
      if (prefersReducedMotion) {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
        return;
      }

      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, CLOSE_MS);
    };

    root.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;

      const closeBtn = t.closest('[data-cards-modal-close]');
      if (closeBtn && modal.contains(closeBtn)) {
        e.preventDefault();
        close();
        return;
      }

      const opener = t.closest('[data-cards-modal-open]');
      if (opener && root.contains(opener)) {
        e.preventDefault();
        const panelId = opener.getAttribute('data-cards-modal-target') || '';
        if (!panelId) return;
        open(panelId, opener);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
    });

    // Click outside drawer closes
    modal.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.classList.contains('cards-modal__backdrop')) close();
      // clicking empty area of modal (outside drawer) should close
      if (drawer && !drawer.contains(t) && t.classList.contains('cards-modal')) close();
    });
  }
}

